/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import * as React from "react";
import { InputProps } from "../../types/InputProps";

class InputRadio extends React.Component<InputProps> {
    handleChange(event) {
        this.props.onChange(event.target.value, event.target);
    }

    render() {
        return (
            <FormControl
                component="fieldset"
                required={this.props.required}
                style={{ opacity: this.props.disabled ? 0.5 : 1 }}
            >
                {this.props.label && (
                    <FormLabel component="legend" required={this.props.required}>
                        {this.props.label}
                    </FormLabel>
                )}
                <RadioGroup
                    row={true}
                    name={this.props.name ? this.props.name : this.props.label}
                    value={this.props.value ? this.props.value : ""}
                    onChange={this.handleChange.bind(this)}
                >
                    {this.props.items.map((item) => {
                        return (
                            <FormControlLabel
                                key={item.name}
                                value={item.name}
                                control={
                                    <Radio
                                        required={this.props.required}
                                        inputProps={{
                                            readOnly: this.props.readonly,
                                            required: this.props.required,
                                            disabled: this.props.disabled,
                                        }}
                                        color="primary"
                                    />
                                }
                                label={item.label}
                            />
                        );
                    })}
                </RadioGroup>
            </FormControl>
        );
    }
}

export default InputRadio;



// WEBPACK FOOTER //
// ./src/components/InputRadio/InputRadio.tsx